export default __webpack_public_path__ + "static/char-s-56-ja-9f6fe8e28949885f37e1edd00f7f2134.png";